module.exports = __webpack_public_path__ + "static/assets/fc521715b5b3316d56f8e7adbc4026cf.gif";